import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _get from 'lodash/get';
import styles from './Table.module.scss';

const TableRow = ({ columns, item, emptyCellContent, hasCellMinWidth, className, selected, centeredText, ...rest }) => {
  const classNames = classnames(
    {
      'is-selected': selected
    },
    className
  );
  return (
    <tr className={classNames} {...rest}>
      {
        columns.map(column => {
          const value = _get(item, column.id, '');
          const cellContent = (column.render ? column.render(value, item, column) : value) || emptyCellContent;
          const cellClassName = column.cellProps ? column.cellProps.className : null;
          return (
            <td
              key={`${column.id}_${item.id}`}
              {...column.cellProps}
              className={classnames({
                [styles.minWidth]: hasCellMinWidth,
                'has-text-centered': centeredText,
              }, cellClassName)}
            >
              {cellContent}
            </td>
          );
        })
      }
    </tr>
  );
};

TableRow.propTypes = {
  className: PropTypes.string,
  columns: PropTypes.array.isRequired,
  emptyCellContent: PropTypes.any,
  item: PropTypes.shape({
    id: PropTypes.string.isRequired
  }).isRequired,
  selected: PropTypes.bool,
  hasCellMinWidth: PropTypes.bool,
  centeredText: PropTypes.bool,
};

TableRow.defaultProps = {
  className: null,
  emptyCellContent: '',
  selected: false,
  hasCellMinWidth: false,
  centeredText: false,
};

export { TableRow };
